import { render, staticRenderFns } from "./ProjectComplaintDetail.vue?vue&type=template&id=7e0172ae&scoped=true&"
import script from "./ProjectComplaintDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectComplaintDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectComplaintDetail.vue?vue&type=style&index=0&id=7e0172ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0172ae",
  null
  
)

export default component.exports